import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { memo } from "react";
import { Text } from "@mantine/core";
import Notification from "./Notification";
const DefaultAlertTemplate = ({ style, options, message, close, }) => {
    const getWarning = (message) => 
    // really?
    message.warningMessage;
    const getType = (isWarn, options) => isWarn ? "warn" : options.type ? options.type : "info";
    const warnMessage = getWarning(message);
    return (_jsx("div", { style: style, children: _jsx(Notification, { type: getType(!!warnMessage, options), close: close, children: _jsx(Text, { weight: 500, span: true, children: warnMessage ? warnMessage : message }) }) }));
};
export default memo(DefaultAlertTemplate);
